import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NdcOfferDetailAlV1Component } from './ndc-offer-detail-al-v1/ndc-offer-detail-al-v1.component';



@NgModule({
  declarations: [
    NdcOfferDetailAlV1Component
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NdcOfferDetailAlV1Component
  ]
})
export class NdcOfferDetailModule { }
